import { z } from 'zod';

/**
 * Backend wpina cały przelew w jedną rezerwację (`matchToBooking`), więc
 * formularz nie ma pola kwoty — zostaje wybór rezerwacji i notatka.
 * `clientId` nie jedzie do API: zawęża listę rezerwacji w drugim pickerze.
 */
export const matchTransactionSchema = z.object({
  clientId: z.string().min(1, 'Zapisujący jest wymagany'),
  bookingId: z.string().min(1, 'Rezerwacja jest wymagana'),
  notes: z.string().default(''),
});

export type MatchTransactionFormData = z.infer<typeof matchTransactionSchema>;
export type MatchTransactionInputData = z.input<typeof matchTransactionSchema>;
